export default `
  <a href="https://dashboard.rapyd.net/login" role="button" target="_blank" class="btn btn-primary login-btn">Log In</a>
`;
